export default class EventBus {
    constructor() {

    }

    dispatch(eventName, eventData) {
        let event = new CustomEvent(eventName, {detail: eventData});
        window.dispatchEvent(event);
    }

    handle(eventName, handleFunction) {
        let handleFunctionProxy = handleFunction;
        if (typeof handleFunctionProxy !== 'function') {
            handleFunctionProxy = function (event) {
                console.log("There is no handle for the event " + eventName);
            }
        }
        else {
            handleFunctionProxy = function (event) {
                handleFunction(event.detail);
            }
        }

        return window.addEventListener(eventName, handleFunctionProxy);
    }
}

export const EventName = {
    InitVerifyCodeForm : "InitVerifyCodeForm",
    InitVerifyPhoneNumberForm : "InitVerifyPhoneNumberForm",
    VerifyPhoneNumberResponded : "VerifyPhoneNumberResponded",
    FinanceEligibilityResponded: "FinanceEligibilityResponded",

    EnquirySentSuccess : "EnquirySentSuccess",
    EnquiryThankYouResponded : "EnquiryThankYouResponded",
    EnquirySaveCar : "EnquirySaveCar",

    EventTriggerBlockoReject: "Enquiry.ViewNumber.BlockoRejected",
    PostCodeChanged: "Postcode.Changed",
    GenericEnquiryFormError : "GenericEnquiryFormError",
    InsuranceFetched: "InsuranceFetched",
    PhoneNumberLoaded: "PhoneNumberLoaded"
}
